import ContentListPage from "../Commaon/ContentListPage";
import RedirectPicker, { LinkValue } from "../Commaon/RedirectPicker";
import { serializeLink, validateLink } from "../../utils/contentLinks";

// Each placement maps to the backend's `app` + `isLoginSlider` fields.
// Only the user app home slider can redirect on tap; login slides are plain images.
const PLACEMENTS = [
  { value: "user_login", label: "User App – Login", app: "user", isLoginSlider: true },
  { value: "user_home", label: "User App – Home", app: "user", isLoginSlider: false },
  { value: "technician_login", label: "Technician App – Login", app: "technician", isLoginSlider: true },
];

const getPlacement = (slider) => {
  if (slider.app === "technician") return "technician_login";
  return slider.isLoginSlider ? "user_login" : "user_home";
};

const getPlacementLabel = (slider) =>
  PLACEMENTS.find((item) => item.value === getPlacement(slider))?.label || "-";

const findPlacement = (value) => PLACEMENTS.find((item) => item.value === value) || PLACEMENTS[0];

const renderLink = (slider) =>
  getPlacement(slider) === "user_home" && slider.link ? (
    <LinkValue link={slider.link} truncate />
  ) : (
    <span className="text-muted">-</span>
  );

const EXTRA_COLUMNS = [
  { header: "Placement", width: "190px", render: getPlacementLabel },
  { header: "Redirect", render: renderLink },
];

const SlidersList = () => (
  <ContentListPage
    title="Sliders"
    singular="slider"
    plural="sliders"
    endpoint="/admin/slider"
    imageField="sliderImage"
    extraColumns={EXTRA_COLUMNS}
    getEmptyForm={() => ({ placement: PLACEMENTS[0].value, link: null })}
    toForm={(slider) => ({ placement: getPlacement(slider), link: slider.link || null })}
    validate={(form) => ({ link: form.placement === "user_home" ? validateLink(form.link) : "" })}
    appendFormData={(formData, form) => {
      const placement = findPlacement(form.placement);
      formData.append("app", placement.app);
      formData.append("isLoginSlider", String(placement.isLoginSlider));
      formData.append("link", placement.value === "user_home" ? serializeLink(form.link) : "");
    }}
    renderLeadingFields={({ form, setField, loading }) => (
      <div className="mb-3">
        <label className="form-label">Placement</label>
        <select
          className="form-select"
          value={form.placement}
          onChange={(e) => setField("placement", e.target.value)}
          disabled={loading}
        >
          {PLACEMENTS.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </div>
    )}
    renderTrailingFields={({ form, setField, errors, loading }) =>
      form.placement === "user_home" ? (
        <RedirectPicker
          value={form.link}
          onChange={(link) => setField("link", link)}
          error={errors.link}
          disabled={loading}
        />
      ) : null
    }
    getViewDetails={(slider) => [
      { label: "Placement", value: getPlacementLabel(slider) },
      ...(getPlacement(slider) === "user_home"
        ? [{ label: "Redirect", value: <LinkValue link={slider.link} /> }]
        : []),
    ]}
  />
);

export default SlidersList;
